import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseDetail } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/courses/$courseId/")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseDetail />
    </RouteGuard>
  ),
});
